<p>update-featured-doctor works!</p>
